import { Icon, Button, Input, Table } from '@driftt/tide-core-legacy'
import { get, sortBy } from 'lodash'
import { Link } from 'react-router'
import { isTeamOnline } from 'utils/TeamOnlineStatusHelper'
import TeamAvailabilityStatusTooltip from './TeamAvailabilityStatusTooltip'

import CreateTeamModal from 'components/settings/team/CreateTeamModal'
import DeleteConfirmModal from 'components/settings/DeleteConfirmModal'

import { HOURS_AVAILABILITY_MODES, HOURS_MODE_COPY } from 'app/modules/teams/constants'

import magnifyingGlassSVG from 'images/svg/magnifying-glass.svg'
import emptyTeamSVG from 'images/svg/empty-team.svg'

import './style.styl'

const TEAM_COLUMNS = [
  {
    label: 'Name',
    value: 'name',
    width: '40%',
  },
  {
    label: 'Hours',
    value: 'hours',
  },
  {
    label: 'Teammates',
    value: 'memberCount',
  },
  {
    label: '',
  },
]

const getTeamOnlineStatus = (availMembersCount, team, teamAvailability) => {
  if(teamAvailability && team && availMembersCount !== undefined){
    return isTeamOnline(availMembersCount, team.autoOffline, team, teamAvailability) ? "Online now" : "Offline now"
  }
  else{
    return ""
  }
}

const RowGenerator = (teams, teamsWithUserAvailability, teamAvailabilities, onTeamEdit, onTeamDelete) => {
  const orderedTeams = sortBy(teams, team => team.name.toLowerCase())
  return orderedTeams.map(team => {
    const teamWithAvail = teamsWithUserAvailability.find(t => t.id === team.id)
    const awayMembersCount = get(teamWithAvail, 'awayMembers.size', 0)
    const availMembersCount = get(teamWithAvail, 'availableMembers.size', 0)

    const teamMembersCount = team.members.length

    const hoursMode = HOURS_MODE_COPY[team.teamAvailabilityMode]
    const showTeamOnlineStatus = team.teamAvailabilityMode === HOURS_AVAILABILITY_MODES.CUSTOM_HOURS
    const teamAvailability = teamAvailabilities.find(ta => ta.id === team.teamAvailabilityId)
    return {
      data: [
        {
          className: 'team-table-name',
          content: <Link to={`/settings/teams/${team.id}`}>{team.name}</Link>,
        },
        {
          className: 'team-table-hours',
          content: (
            <div>
              <div>{hoursMode.title}</div>
              {!!showTeamOnlineStatus && <div className="team-online-status">{getTeamOnlineStatus(availMembersCount, team, teamAvailability)}</div>}
            </div>
          ),
        },
        {
          className: 'team-table-members',
          content: (
            <div>
              <div>{teamMembersCount}</div>
              <div className="member-status">
                {availMembersCount} available / {awayMembersCount} away
              </div>
            </div>
          ),
        },
        {
          content: (
            <div className="team-table-actions">
              <Link to={`/settings/teams/${team.id}`}>
                <Button type="utility">
                  <Icon className="team-table-edit" height={16} width={16} name="edit-1" />
                </Button>
              </Link>
              <Button type="utility" onClick={() => onTeamDelete(team.id)}>
                <Icon className="team-table-delete" height={16} width={16} name="trash" />
              </Button>
            </div>
          ),
        },
      ],
    }
  })
}

const EmptySearchState = () => (
  <div className="team-table-empty-state">
    <img src={magnifyingGlassSVG} />
    <p>
      Oops! Looks like the team you’re searching for doesn’t exist. <br /> Refine your search terms and we’ll
      see if we can find it.
    </p>
  </div>
)

const EmptyTeamsState = ({ onTeamCreateClick }) => (
  <div className="team-table-empty-state">
    <img src={emptyTeamSVG} />
    <p>
      You know what they say - teamwork makes the dream work! <br /> Once you make a team you’ll see it here.
    </p>
    <Button onClick={onTeamCreateClick} size="small">
      Create a team
    </Button>
  </div>
)

const Header = ({ children }) => (
  <div className="teams-management-settings-header">
    <div className="teams-management-settings-header-left">
      <div className="teams-management-settings-header-description">
        <span>Create teams to route conversations to teammates within your organization.</span>
        <a href="https://help.drift.com/article/team-hours" target="_blank"> Learn More</a>
      </div>
    </div>
    {children}
  </div>
)

const TeamsListTable = ({
  teams,
  teamsEmpty,
  searchResultsEmpty,
  onTeamSearch,
  visibleTeams,
  teamsWithMemberAvailability,
  teamAvailabilities,
  showCreateModal,
  openTeamCreateModal,
  openTeamEditModal,
  openTeamDeleteModal,
  showDeleteModal,
  onConfirmDelete,
  deletingTeamId,
  resetModals,
}) => {
  const rowData = RowGenerator(
    visibleTeams,
    teamsWithMemberAvailability,
    teamAvailabilities,
    openTeamEditModal,
    openTeamDeleteModal
  )
  const teamToDelete = teams.find(t => t.id === deletingTeamId)
  return (
    <div>
      <Header>
        <Button onClick={openTeamCreateModal}>New team</Button>
      </Header>
      <div className="teams-list-container">
        <div className="teams-list-search">
          {!!teams && <p className="team-view-count">{`${teams.length} Teams`}</p>}
          <Input
            className="team-view-search-input"
            placeholder="Search..."
            onChange={onTeamSearch}
            type="text"
          />
        </div>
        <Table className="teams-table" columns={TEAM_COLUMNS} data={rowData} />
        <TeamAvailabilityStatusTooltip/>

        {teamsEmpty && <EmptyTeamsState onTeamCreateClick={openTeamCreateModal} />}
        {!teamsEmpty && searchResultsEmpty && <EmptySearchState />}

        {showCreateModal && <CreateTeamModal onCancelTeamCreate={resetModals} />}
        {showDeleteModal && (
          <DeleteConfirmModal title="Delete Team" onClose={resetModals} onConfirm={onConfirmDelete}>
            <p>
              Are you sure you want to delete {!!teamToDelete ? <strong>{teamToDelete.name}</strong> : 'this team'}?
            </p>
            <p>Any playbooks routing to this team will revert to routing to the individuals on the team</p>
          </DeleteConfirmModal>
        )}
      </div>
    </div>
  )
}

export default TeamsListTable



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamsList/component.js